<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll"
    @check-none="checkNone"
    @set-selected-row="setSelectedRow"
    :show-checks="showChecks"
    :showDetailButton="showDetailButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-detail-form="$emit('open-detail-form', $event)"
  />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as EMAIL_TYPOLOGY_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'EmailTypologyTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        {
          key: 'checks',
          label: this.$t('Checks')
        },
        {
          key: 'status',
          label: this.$t('Status'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'status'
        },
        {
          key: 'code',
          label: this.$t('Code'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'code'
        },
        {
          key: 'name',
          label: this.$t('Name'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'name'
        },
        {
          key: 'slug',
          label: this.$t('Slug'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'slug'
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: ['status', 'code', 'name', 'slug']
    }
  },
  computed: {
    ...mapGetters({
      selectAll: EMAIL_TYPOLOGY_TYPES.GENERIC.organization.emailtypology.LIST.GETTERS.selectAll,
      selectedList: EMAIL_TYPOLOGY_TYPES.GENERIC.organization.emailtypology.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showDetailButton () {
      return hasPerm('organization_emailtypology_retrieve')
    }
  },
  methods: {
    ...mapMutations({
      setList: EMAIL_TYPOLOGY_TYPES.GENERIC.organization.emailtypology.LIST.MUTATIONS.setList,
      setSelectedList:
        EMAIL_TYPOLOGY_TYPES.GENERIC.organization.emailtypology.LIST.MUTATIONS.setSelectedList,
      setSelectAll: EMAIL_TYPOLOGY_TYPES.GENERIC.organization.emailtypology.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...EMAIL_TYPOLOGY_TYPES.GENERIC.organization.emailtypology.LIST.ACTIONS
    })
  }
}
</script>
